import { UserListItemDto as IUserListItemDto } from './userConfig'

import { BaseTierDto } from './finance/financeConfig'
import { ReplicationDto } from './emailConfig'
import { Billable } from './registration/timeConfig'
import { DimensionPivotValues } from '../components/Form/Accounting/DimensionFields'
import { FileModuleDto } from '../hooks/module/useFileModule'
import { AttributeEntityDto } from '../hooks/useAttributes'

export interface IReferenceDto {
    id: string
    reference: string
    name: string
}

export interface IOverviewItemDto {
    id: string
    owner: IUserListItemDto
    executiveIds?: string[]
    reference: string
    name: string
    documentRootId: string
    currency: string
    rate: string
    language: string
    status: FileStatus
    lastAccess: string
}

export type FileMutationDto = RateDto &
    AttributeEntityDto & {
        status: FileStatus
        reference: string
        name: string
        description?: string
        ownerId: string
        executiveIds?: string[]
        documentRootId?: string
        language: string
        vatType: string
        paymentCurrency?: string
        dateOfIncident?: string
        archiveLocation?: string
        invoiceName?: string
        unit?: string
        accounting?: DimensionPivotValues
        authorization?: {
            individuals: string[]
            groups: string[]
        }
        modules?: FileModuleDto[]
    }

export type RateDto = {
    billable?: Billable
    currency: string
    rate?: string
    tiers?: BaseTierDto[]
}

export type ScaffoldDto = Pick<FileMutationDto, 'status' | 'reference' | 'rate' | 'vatType' | 'paymentCurrency'>

export interface IFileDto extends IOverviewItemDto {
    description: string
    archiveLocation: string
    invoiceName: string
    vatType: string
    dateOfIncident: string
    mailFolders: ReplicationDto[] // Contains the user-specific replication folders for this file.
    unit?: string
    accounting?: DimensionPivotValues
    modules?: FileModuleDto[]
    paymentCurrency?: string
}

export enum FileStatus {
    Open = 'OPEN',
    Archived = 'ARCHIVED',
}

export enum FileAction {
    GetOverview = 'GET_FILE_OVERVIEW',
    GetMutation = 'GET_MUTATION_FILE',
    GetList = 'GET_FILE_LIST',
    GetEmails = 'GET_FILE_EMAILS',
    GetNotes = 'GET_FILE_NOTES',
    GetTasks = 'GET_FILE_TASKS',
    GetTimes = 'GET_FILE_TIMES',
    Get = 'GET_FILE',
    Add = 'ADD_FILE',
    Update = 'UPDATE_FILE',
    Delete = 'DELETE_FILE',
    ResetCurrent = 'RESET_CURRENT_FILE',
    ResetOverview = 'RESET_FILE_OVERVIEW',
    ResetList = 'RESET_FILE_LIST',
    ResetEmails = 'RESET_FILE_EMAILS',
    ResetNotes = 'RESET_FILE_NOTES',
    ResetTasks = 'RESET_FILE_TASKS',
    ResetTimes = 'RESET_FILE_TIMES',
    OverviewSettings = 'FILE_OVERVIEW_SETTINGS',
}
